// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__blKAw","textarea":"styles_textarea__mAOMS"};